module.exports = __webpack_public_path__ + "static/media/ic-marker-map-rede-me.e3891212.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/IconsMap/ic-marker-map-rede-me.svg
// module id = 988
// module chunks = 0